(function (w, d) {
  'use strict';
  if (w.JPSConversionEvents) return;
  var qaKey = 'jps_analytics_opt_out', qa = false, sequence = 0, attempts = {}, lastSelection = '';
  try {
    var params = new URLSearchParams(w.location.search);
    qa = params.get('jps_qa') === '1';
    if (qa) w.localStorage.setItem(qaKey, '1');
  } catch (ignored) {}
  function allowed() {
    try {
      return !qa && w.localStorage.getItem(qaKey) !== '1' &&
        w.Shopify && !w.Shopify.designMode &&
        w.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (ignored) { return false; }
  }
  function id(value) { value = String(value || ''); return /^\d{1,20}$/.test(value) ? value : ''; }
  function choice(value, options) { return options.indexOf(value) >= 0 ? value : 'not_applicable'; }
  function context() {
    var root = d.querySelector('[data-jps-conversion-product]');
    var select = d.getElementById('variantSel'), button = d.getElementById('pdpAdd');
    var option = select && select.options[select.selectedIndex];
    var product = root && id(root.getAttribute('data-product-id'));
    var variant = id(select ? select.value : button && button.getAttribute('data-add'));
    if (!product) return null;
    return {
      schema_version: '1', product_id: product, variant_id: variant,
      case_choice: choice(option && option.getAttribute('data-jps-case-choice'), ['with_case', 'without_case']),
      configuration_choice: choice(option && option.getAttribute('data-jps-config-choice'), ['configured'])
    };
  }
  function publish(name, payload) {
    if (!allowed() || !payload) return false;
    try {
      if (!w.Shopify.analytics || typeof w.Shopify.analytics.publish !== 'function') return false;
      var result = w.Shopify.analytics.publish('jps:' + name, payload);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return result !== false;
    } catch (ignored) { return false; }
  }
  function selected() {
    var data = context();
    if (!data || !data.variant_id) return;
    var key = [data.product_id, data.variant_id, data.case_choice, data.configuration_choice].join(':');
    if (lastSelection === key) return;
    lastSelection = key;
    publish('configuration_selected', data);
  }
  function cartAttempt(items) {
    var data = context();
    if (!allowed() || !data || !data.variant_id || !Array.isArray(items)) return null;
    var item = items.filter(function (row) { return id(row.id) === data.variant_id; })[0];
    if (!item) return null;
    var quantity = Number(item.quantity);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10000) return null;
    var key = String(Date.now()) + '-' + (++sequence) + '-' + Math.random().toString(36).slice(2, 10);
    data.quantity = quantity;
    data.operation_id = key;
    if (!publish('cart_attempt', data)) return null;
    attempts[key] = {data: data, expires: Date.now() + 120000};
    Object.keys(attempts).forEach(function (token) { if (attempts[token].expires < Date.now()) delete attempts[token]; });
    return key;
  }
  function cartResult(token, result, added) {
    var attempt = attempts[token];
    if (!attempt) return;
    delete attempts[token];
    if (attempt.expires < Date.now() || !allowed()) return;
    var status = result && result.status;
    if (['added', 'rejected', 'uncertain'].indexOf(status) < 0) return;
    var rows = added && (Array.isArray(added.items) ? added.items : [added]);
    var matched = rows && rows.some(function (row) {
      return id(row.variant_id || row.id) === attempt.data.variant_id;
    });
    if (status === 'added' && !matched) status = 'uncertain';
    var data = Object.assign({}, attempt.data, {outcome: status});
    publish(status === 'added' ? 'cart_success' : status === 'rejected' ? 'cart_failure' : 'cart_uncertain', data);
  }
  w.JPSConversionEvents = {
    cartAttempt: cartAttempt,
    cartResult: cartResult,
    isAllowed: allowed,
    optOut: function () { qa = true; attempts = {}; try { w.localStorage.setItem(qaKey, '1'); } catch (ignored) {} }
  };
  d.addEventListener('change', function (event) {
    if (!event.isTrusted || !event.target) return;
    if (event.target.id === 'variantSel') selected();
    else if (['jpsMaterial', 'jpsConfigurationFlow'].indexOf(event.target.id) >= 0) Promise.resolve().then(selected);
  });
  d.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('[data-jps-fit-help]');
    if (!target) return;
    var kind = target.getAttribute('data-jps-fit-help');
    if (['phone', 'contact', 'finder'].indexOf(kind) < 0) return;
    var data = context();
    if (data) { data.help_type = kind; publish('fit_help_clicked', data); }
  }, true);
  d.addEventListener('visitorConsentCollected', function () { if (!allowed()) attempts = {}; });
  try {
    if (w.Shopify && !w.Shopify.customerPrivacy && typeof w.Shopify.loadFeatures === 'function') {
      w.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function () {});
    }
  } catch (ignored) {}
})(window, document);
